<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Rabatt bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.discounts.update', discount))">
                <form-fields :form="form" :discount="discount" :discount-type-options="discountTypeOptions" :category-tree="categoryTree" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'discount',
            'categoryTree',
            'discountTypeOptions'
        ],
        data() {
            return {
                form: this.$inertia.form({
                    discount_type: this.discount.discount_type,
                    name: this.discount.name,
                    description: this.discount.description,
                    enabled: this.discount.enabled,
                    amount: this.discount.amount,
                    min_order_amount: this.discount.min_order_amount,
                    max_order_amount: this.discount.max_order_amount,
                    min_total_revenue: this.discount.min_total_revenue,
                    max_total_revenue: this.discount.max_total_revenue,
                    valid_from: this.discount.valid_from,
                    valid_until: this.discount.valid_until,
                    customers: this.discount.customers,
                    exclude_customers: this.discount.exclude_customers,
                    products: this.discount.products,
                    exclude_products: this.discount.exclude_products,
                    categories: this.discount.categories,
                    exclude_categories: this.discount.exclude_categories,
                    manufacturers: this.discount.manufacturers,
                    exclude_manufacturers: this.discount.exclude_manufacturers,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>